// extracted by mini-css-extract-plugin
export default {"container":"Lj-z","blurb":"Mj-z","links":"Nj-z"};